import { STORAGE_KEYS } from '@/lib/constants';
import { safeLocalStorage } from '@/lib/safeStorage';
import { clearCompanyDraft } from '@/lib/companyDraft';
import { clearSignupPhone } from '@/lib/signupPhone';
import { rememberShopName, shopNameFromSearch } from '@/lib/shopFromSearch';

const REGISTRATION_STORAGE_KEY = 'ruta_registration_state';

/**
 * Two things can be handed over in the address bar when someone arrives to sign up:
 * `shop`, the company name typed on the marketing site, and `fresh`, the signup
 * tooling asking for a clean slate. Both are taken in and taken straight back out
 * here — before the app boots, so no half-finished session can carry the visitor
 * into a dashboard, and with nothing left in the address bar for them to read.
 */
export function applySignupHandoff(): void {
  const url = new URL(window.location.href);
  const shopName = shopNameFromSearch(url.searchParams);
  const startClean = url.searchParams.has('fresh');
  if (!shopName && !startClean) return;

  if (startClean) {
    safeLocalStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
    safeLocalStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    safeLocalStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    safeLocalStorage.removeItem(STORAGE_KEYS.VIEW_AS);
    safeLocalStorage.removeItem(REGISTRATION_STORAGE_KEY);
    safeLocalStorage.setItem(STORAGE_KEYS.HAS_LOGGED_OUT, 'true');
    clearCompanyDraft();
    clearSignupPhone();
  }
  if (shopName) rememberShopName(shopName);

  url.searchParams.delete('shop');
  url.searchParams.delete('fresh');
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
}
